module.exports = __webpack_public_path__ + "media/sub6-2.46b7e92a.mp4";